module.exports = __webpack_public_path__ + "static/img/consumer-h5-7.83dea7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/consumer-h5-7.png
// module id = c3Nn
// module chunks = 34